import type { JSX } from 'react';
import { IconPin1 } from '@taki/ui';

export function IconeEpingle({ pleine = false, size = 12 }: { pleine?: boolean; size?: number }): JSX.Element {
  if (!pleine) return <IconPin1 size={size} />;
  return <svg viewBox="0 0 24 24" width={`${size / 16}rem`} height={`${size / 16}rem`} aria-hidden="true" focusable="false">
    <path fill="currentColor" d="m13.205 22.296 1.587 1.586.514-2.184 1.888-8.025 5.496-3.727 1.252-.849-1.07-1.07-6.9-6.9L14.904.059l-.849 1.252-3.726 5.497-8.025 1.888-2.185.514 1.587 1.587 4.513 4.512-6.16 6.16 2.475 2.474 6.16-6.159z" />
  </svg>;
}
